import React from 'react';
import {Link} from 'react-router-dom';
import '../../../styles/component/breadcrumb.scss';

export type IBreadcrumb = {
    label: string;
    href?: string;
};

export interface BreadcrumbProps {
    data: IBreadcrumb[];
    size?: 'small' | 'medium' | 'large';
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({data, size = 'medium'}) => {

    return (
        <nav
            className={`pn-breadcrumbs pn-breadcrumbs--${size}`}
            aria-label="Breadcrumb"
        >
            <ol className="pn-breadcrumbs__list">
                {data.map((b, index) => {
                    const isLast = index === data.length - 1;

                    return (
                        <li
                            key={`crumb-${index}`}
                            className="pn-breadcrumb__item"
                        >
                            {index > 0 && (
                                <span
                                    className="pn-breadcrumb__sep"
                                    aria-hidden="true"
                                >
                                    /
                                </span>
                            )}

                            {!isLast && b.href ? (
                                <Link
                                    to={b.href}
                                    className="pn-breadcrumb__link"
                                >
                                    {b.label}
                                </Link>
                            ) : (
                                <span
                                    className="pn-breadcrumb__current"
                                    aria-current={isLast ? 'page' : undefined}
                                >
                                    {b.label}
                                </span>
                            )}
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumb;